import sal from 'sal.js'

common.View.create('canvas::canvas.blocks.custom.textImageHeader.Block', {

    onDOMLoad() {
        this.initSal();
    },

    initSal() {
        sal({
            threshold: 0.1,
            once: true,
        });
    }
});
